// Termíny jsou provozovány v ČR — formátujeme i porovnáváme kalendářní dny
// vždy v Europe/Prague, ať výsledek nezávisí na časovém pásmu prohlížeče
// (jinak by např. termín 07:00–15:00 UTC vyšel v Tokiu jako vícedenní).
const TZ = "Europe/Prague";
const DAY = new Intl.DateTimeFormat("cs-CZ", { timeZone: TZ, day: "numeric" });
const DAY_MONTH = new Intl.DateTimeFormat("cs-CZ", { timeZone: TZ, day: "numeric", month: "long" });
const FULL = new Intl.DateTimeFormat("cs-CZ", {
  timeZone: TZ,
  day: "numeric",
  month: "long",
  year: "numeric",
});
const FULL_WEEKDAY = new Intl.DateTimeFormat("cs-CZ", {
  timeZone: TZ,
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
});
// en-CA → "YYYY-MM-DD", robustní na rozparsování kalendářních částí v TZ.
const YMD = new Intl.DateTimeFormat("en-CA", {
  timeZone: TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

interface FormatTerminDateOptions {
  /** U jednodenního termínu předřadí den v týdnu („středa 12. srpna 2026"). */
  weekday?: boolean;
}

/** Kalendářní rok/měsíc/den v Europe/Prague (ne v TZ prohlížeče). */
function pragueYmd(d: Date): { y: number; m: number; day: number } {
  const parts = YMD.formatToParts(d);
  const get = (t: string) => Number(parts.find((p) => p.type === t)?.value ?? Number.NaN);
  return { y: get("year"), m: get("month"), day: get("day") };
}

/**
 * Datum termínu kurzu pro veřejný web. Jednodenní → „12. srpna 2026"
 * (s `weekday` → „středa 12. srpna 2026"), vícedenní → rozmezí s měsícem
 * konzistentně slovy (Intl.formatRange u cs-CZ přepíná na číselný měsíc, proto
 * skládáme ručně; u rozmezí se den v týdnu vynechává, aby text nezaneřádil):
 *   - stejný měsíc:  „12.–14. srpna 2026"
 *   - přes měsíc:    „30. srpna – 2. září 2026"
 *   - přes rok:      „30. prosince 2026 – 2. ledna 2027"
 *
 * `datumDo` smí chybět nebo být ≤ `datumOd` (jednodenní / vadná data) → vrátí
 * jen začátek. Formátuje i porovnává dny v Europe/Prague.
 */
export function formatTerminDate(
  datumOd: string,
  datumDo?: string | null,
  options?: FormatTerminDateOptions,
): string {
  const od = new Date(datumOd);
  if (Number.isNaN(od.getTime())) return "";
  const single = options?.weekday ? FULL_WEEKDAY : FULL;
  if (!datumDo) return single.format(od);

  const doDate = new Date(datumDo);
  if (Number.isNaN(doDate.getTime()) || doDate <= od) return single.format(od);

  const a = pragueYmd(od);
  const b = pragueYmd(doDate);
  if (a.y === b.y && a.m === b.m && a.day === b.day) return single.format(od);

  if (a.y !== b.y) return `${FULL.format(od)} – ${FULL.format(doDate)}`;
  if (a.m !== b.m) return `${DAY_MONTH.format(od)} – ${FULL.format(doDate)}`;
  return `${DAY.format(od)}–${FULL.format(doDate)}`;
}
